package com.essntl.features.invoice.ui.addeditinvoice.components.content.day

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import core.dateformat.utils.formatNumber
import com.essntl.core.utils.utils.pluralize
import com.essntl.features.invoice.ui.addeditinvoice.components.ExpandCollapseArrowWithText
import com.essntl.features.invoice.ui.rememberLocalDate
import com.essntl.uikit.components.checkbox.EsCheckBoxState
import com.essntl.uikit.components.checkbox.EsTriPrimaryCheckBox
import com.essntl.uikit.components.utils.EsModifiers.LargeSectionModifier
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun InvoicingDaySection(
    state: InvoicingDayUiState,
    fromDate: String?,
    onServiceCheckChanged: (id: String, checked: Boolean) -> Unit,
    onCheckAllServices: (checked: Boolean) -> Unit,
) {
    var isExpanded by remember { mutableStateOf(true) }

    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = LargeSectionModifier
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            val checkboxState = remember(state.serviceList) {
                when {
                    state.serviceList.all { it.isChecked } ->
                        EsCheckBoxState.Checked

                    state.serviceList.none { it.isChecked } ->
                        EsCheckBoxState.Unchecked

                    else ->
                        EsCheckBoxState.Indeterminate
                }
            }

            EsTriPrimaryCheckBox(
                state = checkboxState,
                onClick = {
                    onCheckAllServices(checkboxState != EsCheckBoxState.Checked)
                },
            )

            Spacer(modifier = Modifier.width(1.spacing))

            val localDate = rememberLocalDate(state.index, fromDate)

            if (localDate != null) {
                Text(
                    text = "${formatNumber(localDate.monthNumber)}.${formatNumber(localDate.dayOfMonth)}",
                    color = MaterialTheme.esColorScheme.textPrimary,
                    style = MaterialTheme.esTypography.h4SemiBold20,
                )

                Spacer(modifier = Modifier.width(1.spacing))

                Text(
                    text = localDate.dayOfWeek.name.substring(0, 3),
                    color = MaterialTheme.esColorScheme.textSecondary,
                    style = MaterialTheme.esTypography.p1Regular16,
                )
            }

            Spacer(modifier = Modifier.weight(1f))

            ExpandCollapseArrowWithText(
                text = state.serviceList.size.pluralize("service"),
                isExpanded = isExpanded,
                onToggleExpanded = {
                    isExpanded = !isExpanded
                }
            )
        }

        AnimatedVisibility(
            visible = isExpanded,
            modifier = Modifier
                .fillMaxWidth()
        ) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(2.spacing),
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = 3.spacing)
            ) {
                if (state.serviceList.isEmpty())
                    Text(
                        text = "No services in this day",
                        style = MaterialTheme.esTypography.p1Regular16,
                        color = MaterialTheme.esColorScheme.textSecondary
                    )

                state.serviceList.forEach { service ->
                    PaymentLinkDayServiceItem(
                        state = service,
                        onCheckedChange = { checked ->
                            onServiceCheckChanged(service.id, checked)
                        },
                        modifier = Modifier.fillMaxWidth()
                    )
                }
            }
        }
    }
}
